module.exports = __webpack_public_path__ + "static/media/map-screenshot.48305d68.png";